function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M102.577 53.793 26.484 24.539a1.54 1.54 0 0 0-1.635.35l-.034.034a1.55 1.55 0 0 0-.35 1.635L53.72 102.65c.222.587.784.97 1.405.98a1.53 1.53 0 0 0 1.431-.946l9.291-22.33L79.362 93.87a2.23 2.23 0 0 0 3.15 0c3.11-3.108 8.168-8.167 11.276-11.275a2.23 2.23 0 0 0 0-3.151L80.29 65.929l22.33-9.292c.579-.238.953-.809.945-1.43a1.56 1.56 0 0 0-.988-1.414",
    className: "icon_svg__black",
    style: {
      fill: "#34a3d3"
    }
  }));
};
export default SvgIcon;